import React from 'react';

import CourseProgress from './CourseProgress';
import {
  ExerciseContainer,
  SyllabusContainer,
  FlowModuleName,
  FlowModuleDescription,
  NameAndDescriptionsContainer,
} from './styles';

export default function CourseModule({
  course,
  user,
  language,
  firstIncompleteLevel,
  setDisplayCourseSignUpModal,
  handleClickOnLevelName,
}) {
  return (
    <SyllabusContainer>
      {course?.syllabus?.map((lesson, syllabusIndex) => (
        <div key={lesson.name} id={syllabusIndex}>
          <NameAndDescriptionsContainer>
            <FlowModuleName>{lesson.name}</FlowModuleName>
            <FlowModuleDescription>{lesson.description}</FlowModuleDescription>
          </NameAndDescriptionsContainer>
          {lesson?.modules?.map((module, moduleIndex) => (
            <ExerciseContainer key={moduleIndex} id={`mod-${moduleIndex}`}>
              <CourseProgress
                user={user}
                course={course}
                language={language}
                exerciseId={module.exercise.id}
                syllabusIndex={syllabusIndex}
                levelNames={module.exercise.languagesCompleted[language === 'any' ? 'python' : language]}
                moduleName={module.name}
                icon={module.icon}
                exerciseName={module.exercise.name}
                isCompletedInAnyLanguage={language === 'any' ? module.exercise.isCompletedInAnyLanguage : false}
                languagesCompleted={module.exercise.languagesCompleted}
                testImpl={module.exercise.testImpl}
                moduleIndex={moduleIndex}
                inputExercise={module.exercise.inputExercise}
                exerciseAccessLevel={module.accessLevel}
                lesson={lesson}
                firstIncompleteLevel={firstIncompleteLevel}
                setDisplayCourseSignUpModal={setDisplayCourseSignUpModal}
                handleClickOnLevelName={handleClickOnLevelName}
              />
            </ExerciseContainer>
          ))}
        </div>
      ))}
    </SyllabusContainer>
  );
}
